import { encryptTT } from '@/utils/encryption';

import { LANGUAGE_MAP, MI_SUPPORT_CHANNEL, MI_SUPPORT_SYSTEM } from './constants';

/** 构建支持系统 API 请求体参数 */
export function buildSupportParams(userName: string) {
  const rmsEnvCountry = JSON.parse(localStorage.getItem('rmsEnvCountry') || '{}');
  const region = localStorage.getItem('region') || '';
  const euCountries = rmsEnvCountry?.euCountries || [];
  const isEuCountry = euCountries.includes(region);
  const lang = LANGUAGE_MAP[localStorage.getItem('locale') as keyof typeof LANGUAGE_MAP] || 'en';

  return {
    userName: encryptTT(userName),
    channel: MI_SUPPORT_CHANNEL,
    system: MI_SUPPORT_SYSTEM,
    location: isEuCountry ? 'eu' : 'other',
    lang
  };
}

/** 构建 iframe URL 的 query 参数字符串 */
export function buildSupportQueryParams(userName: string): string {
  const params = buildSupportParams(userName);
  return `user_id=${params.userName}&channel=${params.channel}&system=${params.system}&location=${params.location}&lang=${params.lang}`;
}
